import React from "react";

import TopBar from "../../components/site/TopBar";

import { Header } from "./styles";

const Home: React.FC = () => {
  return (
    <Header>
      <TopBar />
    </Header>
  );
};

export default Home;
